import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { APIV2 } from "services/ApiServiceV2";

export const authLogin = createAsyncThunk("auth/authLogin", async (arg, thunkAPI) => {
    return await APIV2(`login`, "POST", arg, "NODE")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});
export const resendOtp = createAsyncThunk("auth/resendOtp", async (arg, thunkAPI) => {
    return await APIV2(`sendOtp`, "POST", arg, "NODE")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});
export const verifyOtp = createAsyncThunk("auth/verifyOtp", async (arg, thunkAPI) => {
    return await APIV2(`verifyOtp`, "POST", arg, "NODE")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const googleSignIn = createAsyncThunk("auth/googleSignIn", async (arg, thunkAPI) => {
    return await APIV2(`googleLogin`, "POST", arg, "NODE")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
}); 

export const appleSignIn = createAsyncThunk("auth/appleSignIn", async (arg, thunkAPI) => {
    return await APIV2(`appleLogin`, "POST", arg, "NODE")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
}); 





let initialState = {
    userId: null,
    webOpenCount: -1,
    newsPopUpShownCount: 0,
    localNewsLetterSubscribed: false,
    appDownloadPopupShownCount: 0,
    appDownloadPopupShown: false,
    appDownloadLastClosedTime: null,
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setUserId: (state, action) => {
            state.userId = action.payload;
        },
        resetAuthSlice: (state) => {
            state.userId = null;
            state.webOpenCount = 0;
        },
        incrementWebOpenCount: (state, action) => {
            state.webOpenCount = state.webOpenCount + 1;
        },
        setLocalNewsLetterSubscribed: (state, action) => {
            state.localNewsLetterSubscribed = action.payload;
        },
        incrementnewsPopUpShownCount: (state, action) => {
            state.newsPopUpShownCount = (state?.newsPopUpShownCount || 0) + 1;
        },
        setAppDownloadPopupShown: (state, action) => {
            state.appDownloadPopupShown = action.payload;
        },
        incrementAppDownloadPopupShownCount: (state, action) => {
            state.appDownloadLastClosedTime = new Date();
            state.appDownloadPopupShownCount = (state?.appDownloadPopupShownCount || 0) + 1;
        },
        resetAppDownloadPopupShownCount: (state, action) => {
            state.appDownloadPopupShownCount = 0;
            state.appDownloadLastClosedTime = null;
        },

    },
    extraReducers: (builder) => {},
});

export const {
    setUserId,
    resetAuthSlice,
    incrementWebOpenCount,
    incrementnewsPopUpShownCount,
    setLocalNewsLetterSubscribed,
    setAppDownloadPopupShown,
    incrementAppDownloadPopupShownCount,
    resetAppDownloadPopupShownCount,
} = authSlice.actions;

export default authSlice.reducer;
